let helper = new Object()

helper.format = (date) => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()} GMT ${-date.getTimezoneOffset() / 60}`
}

helper.date = (data) => {
  if (!data) return null
  let dt = new Date(data)
  let dtStr = `${addZeroChar(dt.getDate())}.${addZeroChar(dt.getMonth() + 1)}.${dt.getFullYear()}`
  return dtStr
}

helper.datetime = (data) => {
  if (!data) return null
  let dt = new Date(data)
  let dtStr = `${addZeroChar(dt.getDate())}.${addZeroChar(dt.getMonth() + 1)}.${dt.getFullYear()} ${addZeroChar(dt.getHours())}:${addZeroChar(dt.getMinutes())}:${addZeroChar(dt.getSeconds())}`
  return dtStr
}

helper.time = (data) => {
  if (!data) return null
  let dt = new Date(data)
  let dtStr = `${addZeroChar(dt.getHours())}:${addZeroChar(dt.getMinutes())}:${addZeroChar(dt.getSeconds())}`
  return dtStr
}

function addZeroChar (param) {
  if (param.toString().length < 2) param = `0${param}`
  return param
};

export default helper
